/*!
 * Built with Stencil
 *  Components for Katal Community Components
 *  Copyright (c) Amazon
 */
function t(bundle, message, args = {}) {
  return args ? bundle.formatMessage(message, args) : bundle.getMessage(message);
}

export { t };

//# sourceMappingURL=get-message.js.map